import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import bg from '../../images/bg-parcking.svg'
import Logo from '../../images/logo-black.svg'
import './parcking.css'

const DEEP_LINK_SCHEME = 'respublikapark://'


type Props = {}

interface DynamicImportOptions {
  onCompleted?: (name: string, ImportedIconRef: any) => void;
  onError?: (err: Error) => void;
}

const importIcon = (name: string, options?: DynamicImportOptions) => {
  return import(`../../images/${name.toLocaleLowerCase()}.svg`).then((module) => {
    if (options?.onCompleted) {
      options.onCompleted(name, module.default);
    }
    return module.default;
  }).catch((err) => {
    if (options?.onError) {
      options.onError(err);
    }
    throw err;
  });
};


const Parcking = (props: Props) => {

  // use dynamic import for images
  const [ImportedIconRef, setImportedIconRef] = useState<any>(null);

  const [searchParams] = useSearchParams()
  const data = searchParams.get('parking')
  const [parckingLvl, setParckingLvl] = React.useState('')



  useEffect(() => {
    importIcon(parckingLvl, {
      onCompleted: (name, ImportedIconRef) => {
        setImportedIconRef(ImportedIconRef);
      },
      onError: (err) => {
        console.error(err);
      },
    });
  }, [parckingLvl]);

  useEffect(() => {
    const url = window.location.href
    const parking = url.split('/').pop()
    const parkingLvl = parking?.split('?')[0]
    setParckingLvl(parkingLvl as string)
  }, [])

  const openInApp = () => {
    if (!parckingLvl || !data) return
    window.location.href = `${DEEP_LINK_SCHEME}parking?level=${parckingLvl}&spot=${data}`
  }

  useEffect(() => {
    if (!parckingLvl || !data) return
    openInApp()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parckingLvl, data])




  // container for all the data

  // using tailwind css
  return (
    <div className="flex justify-center  bg-no-repeat bg-cover" style={{
      backgroundImage: `url(${bg})`,
      minHeight: '100vh',
    }}>
      <div className="flex flex-col  mt-40 max-w-xl max-w-500 min-w-300 parckingContainer">
        <header className='flex items-start justify-start'>
          <img src={Logo} alt="logo" className='w-80' />
        </header>
        <div className="flex flex-col items-center justify-center mt-20">
          <img src={ImportedIconRef} alt="logo" className='w-full' />
        </div>
        <div className="flex flex-col items-center justify-center mt-10">
          <h3 className="text-2xl text-white font-medium text-center">Ваше авто знаходиться тут</h3>
        </div>
        <div className="flex flex-col items-center justify-center mt-10">
          <h3 className="text-9xl text-white font-medium text-center">{data}</h3>
        </div>
        <div className="flex flex-col items-center justify-center mt-10">
          <p className="text-white text-center">Щоб нагадати собі, де залишили авто:
            збережіть цю сторінку у закладках, або зробіть знімок екрану.</p>
        </div>

        <button
          onClick={openInApp}
          className="flex items-center justify-center mt-10 rounded-xl"
          style={{
            backgroundColor: '#2cd5c4',
            border: 'none',
            color: '#fff',
            padding: '14px 28px',
            cursor: 'pointer',
            width: '100%',
          }}
        >
          <h3 className="text-xl font-medium text-center">Відкрити в додатку Republica Park</h3>
        </button>

        <a href="https://respublikapark.com.ua/" target="_blank" rel="noreferrer">
          <button className="flex items-center justify-center mt-6 mb-40 rounded-xl" style={{
            backgroundColor: 'transparent',
            border: '1px solid #2cd5c4',
            color: '#2cd5c4',
          }}>
            <h3 className="text-2xl font-medium text-center">На сайт ТРЦ Respublika Park</h3>
          </button>
        </a>


      </div>
    </div>
  )
}

export default Parcking